import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";

export default function TrainingForm() {
  const [form, setForm] = useState({
    title: "",
    trainer_name: "",
    training_date: "",
    duration: "",
    feedback: "",
    completion_status: "",
    created_at: new Date().toISOString(),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Certification submitted:", form);
    alert("Certification details submitted successfully!");
  };

  const goBack = () => {
    window.history.back(); // or use navigate(-1) if you're using React Router
  };

  return (
    <div style={styles.container}>
      <button onClick={goBack} style={styles.backButton}>
        <FaArrowLeft style={{ marginRight: "6px" }} />
        Back
      </button>

      <h2 style={styles.heading}>Certification Details</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.row}>
          <label style={styles.label}>Certificate Title</label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </div>

        

        <div style={styles.row}>
          <label style={styles.label}>Certification Date</label>
          <input
            type="date"
            name="training_date"
            value={form.training_date}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </div>

        <div style={styles.row}>
          <label style={styles.label}>Duration</label>
          <input
            type="number"
            name="duration"
            value={form.duration}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </div>

        <div style={styles.row}>
          <label style={styles.label}>Description</label>
          <textarea
            name="feedback"
            value={form.feedback}
            onChange={handleChange}
            rows="3"
            placeholder="Enter your feedback..."
            style={styles.textarea}
          />
        </div>

        <div style={styles.row}>
          <label style={styles.label}>Completion Status</label>
          <select
            name="completion_status"
            value={form.completion_status}
            onChange={handleChange}
            required
            style={styles.select}
          >
            <option value="">Select</option>
            <option value="Completed">Completed</option>
            <option value="Ongoing">Ongoing</option>
            <option value="Pending">Pending</option>
          </select>
        </div>

        

        <button type="submit" style={styles.button}>
          Submit Certification Info
        </button>
      </form>
    </div>
  );
}

// Internal CSS
const styles = {
  container: {
    maxWidth: "600px",
    margin: "40px auto",
    background: "#fff",
    padding: "24px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    fontFamily: "Arial",
    position: "relative",
  },
  heading: {
    textAlign: "center",
    marginBottom: "20px",
    color: "#333",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  row: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontWeight: "bold",
    marginBottom: "6px",
    color: "#555",
  },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  textarea: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  select: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  button: {
    padding: "12px",
    backgroundColor: "#4f46e5",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    background: "transparent",
    border: "none",
    color: "#4f46e5",
    fontWeight: "bold",
    fontSize: "15px",
    cursor: "pointer",
    marginBottom: "10px",
  },
};
